import { Fetcher, preload, type SWRConfiguration } from 'swr';
import useSWRImmutable from 'swr/immutable';
import { getActivityGradingCriteria } from '@/api/activityGradingCriteria';
import { QueryKey } from '@/api/queryKey';
import { ActivityGradingCriteria } from '@/model/ActivityGradingCriteria.model';

type Config = SWRConfiguration<ActivityGradingCriteria, unknown, Fetcher<ActivityGradingCriteria>>;

export const useActivityGradingCriteria = (config?: Config) => {
  const { data, isLoading, isValidating, error, mutate } = useSWRImmutable(
    () => QueryKey.GetActivityGradingCriteria(),
    () => getActivityGradingCriteria(),
    config
  );

  return {
    data: data ?? null,
    isLoading,
    isValidating,
    isReady: !isLoading && !isValidating && !error,
    error,
    mutate,
  };
};

export const preloadActivityGradingCriteria = () => {
  return preload(QueryKey.GetActivityGradingCriteria(), () => getActivityGradingCriteria());
};
